import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment-timezone";

//import moment from "moment";

@Pipe({
  name: "utcDateTimeZone",
})
export class UtcDateTimeZonePipe implements PipeTransform {
  /**
   * Takes a datetime and formats it
   */
  transform(
    value: string,
    timezone: string,
    dateOrTimeOnly?: "dateOnly" | "timeOnly"
  ) {
    if (value === null || value === undefined) {
      return "";
    }
    let coalescedTimezone;
    if (timezone) {
      coalescedTimezone = timezone;
    } else {
      coalescedTimezone = moment.tz.guess();
    }
    if (dateOrTimeOnly === "dateOnly") {
      return moment(new Date(value)).tz(coalescedTimezone).format("MM/DD/YYYY");
    } else if (dateOrTimeOnly === "timeOnly") {
      return moment(new Date(value)).tz(coalescedTimezone).format("HH:mm z");
    } else {
      return moment(new Date(value))
        .tz(coalescedTimezone)
        .format("MM/DD/YYYY HH:mm (z)");
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/output-formatters/utc-date-timezone.pipe.ts